import React from 'react'
import Link from 'gatsby-link'

export default () => (
  <header className='px2 pt2 mb2'>
    <div className='relative'>
      <h3 className='mt0 mb1 flex justify-center'>
        <Link 
          to={'/'}
          className='block black text-decoration-none logo'
        >
          <img 
            src={require('images/logo.svg')} 
            className='block fit'
          />
        </Link>
      </h3>
      <ul className='my0 list-reset flex justify-center'>
        {[{
          to: '/',
          children: 'Lessons'
        }, {
          to: '/ski-area/',
          children: 'Ski Area'
        }, {
          to: '/about/',
          children: 'About'
        }].map(link => (
          <li className='mr2'>
            <Link 
              {...link}
              activeClassName='active'
              exact={true}
              className='nav-link black text-decoration-none bold'
            />
          </li>
        ))}
      </ul>
      
      <div className='absolute phone-us right-align h4 xs-hide'>
        <p className='my0'>
          <a href="tel:00330609524793" className='text-decoration-none'>+33(0)609524793</a>
        </p>
        <p className='my0'>
          <Link 
            to={'/contact-us'}
            className='text-decoration-none'
          >
            Contact us
          </Link>
        </p>
      </div>
    </div>
    
  </header>
)
  


// WEBPACK FOOTER //
// ./src/components/Header.js